// just to trigger deploy
const scrollTo = (ref) => {
  window.scroll({
    top: ref.current.offsetTop - 100,
    behavior: 'smooth',
  })
}

export default scrollTo
